import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Navbar from '../navbar/Navbar'
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import Button from '@material-ui/core/Button';
import Footer from '../footer/footer'
import { Link } from "react-router-dom";


const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: '33.33%',
        flexShrink: 0,
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    },
}));

export default function ControlledExpansionPanels() {
    const classes = useStyles();
    const [expanded, setExpanded] = React.useState(false);

    const handleChange = panel => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };
    
    
    return (
        <div className={classes.root}>
            <Navbar />
            <Link id='back' to="/QuestionBank">
                <Button style={{ margin: '10px',marginTop:'70px'  }} variant="contained" color="primary" href="#contained-buttons">
                    <KeyboardBackspaceIcon />
                </Button>
            </Link>
            <h1 id='desc' style={{textAlign:'center'}}>Seventh sem CSE/ISE QB</h1>
   

            <ExpansionPanel expanded={expanded === 'panel1'} onChange={handleChange('panel1')} style={{ marginTop: '40px' }}>
                <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                >
                    <Typography  className={classes.heading}>Storage area network (SAN)</Typography>
                    <Typography  style={{marginLeft:'30px'}}  className={classes.secondaryHeading}>Available</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <Typography>
                        <div style={{ color: 'black' }}> Previous Year Question paper <br/>

                        <a href="https://drive.google.com/file/d/1YHQA8jAvzUt3UDYxSvugza9RXXmS_f5_/view?usp=sharing"> Jan 2019</a><br/>
                        <a href="https://drive.google.com/file/d/1eMOQSgk5dLEgTTokphhjmQHI6M5_I9d1/view?usp=sharing">July 2019</a><br/>
                       
        
                            
                        </div>
                    </Typography>
                </ExpansionPanelDetails>
            </ExpansionPanel>

            <ExpansionPanel expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2bh-content"
                    id="panel2bh-header"
                >
                    <Typography className={classes.heading}>Advanced computer architecture (ACA)</Typography>
                    <Typography  style={{marginLeft:'30px'}}  className={classes.secondaryHeading}>Available</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <Typography>
                        <div style={{ color: 'black' }}> Question Bank <br/>
                         
                            <a href="https://drive.google.com/file/d/1mLWNmMjJxj3N4oqYDzjZVd0aZCmTjdUb/view?usp=sharing"> question bank 1</a><br/>
                            <a href="https://drive.google.com/file/d/1_Okm5q6sExv-uCCSdzws3CxmtsVpMbjk/view?usp=sharing"> question bank 2</a><br/>
                        </div>
                    </Typography>
                    <Typography style={{ marginLeft: "30px" }}>
                        <div style={{ color: 'black' }}> Previous year Question paper <br/>
                         <a href="https://drive.google.com/file/d/1bRAZieges2HJrItz5KjW17JIGRZPhoKk/view?usp=sharing">July 2019 qp</a><br/>
                            <a href="https://drive.google.com/file/d/1nnYLUrsZRHnVujyfZzyTsJGsifYK51Qc/view?usp=sharing">Jan 2019 qp</a><br/>
                            
                        </div>
                    </Typography>
                </ExpansionPanelDetails>
            </ExpansionPanel>

            <ExpansionPanel expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
                <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel3bh-content"
                    id="panel3bh-header"
                >
                    <Typography className={classes.heading}>Web technology and its applications (WEB)</Typography>
                    <Typography  style={{marginLeft:'30px'}}  className={classes.secondaryHeading}> Available</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <Typography>
                    <div style={{ color: 'black' }}> Previous year Question paper <br/>
                       
                    <a href="https://drive.google.com/file/d/1RbuCKDxw9TFeGEG5aYq5zlf1SCfWjrjq/view?usp=sharing">July 2019 qp</a><br/>
                    <a href="https://drive.google.com/file/d/1L_SsafMjCXs_OZLyDfzLsyG19l_-BtT1/view?usp=sharing">Jan 2019 qp</a><br/>
                    </div>
          </Typography>
                </ExpansionPanelDetails>
            </ExpansionPanel>

            <ExpansionPanel expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
                <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel4bh-content"
                    id="panel4bh-header"
                >
                    <Typography className={classes.heading}>Machine learning (ML)</Typography>
                    <Typography  style={{marginLeft:'30px'}}  className={classes.secondaryHeading}> Available</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <Typography>
                    <div style={{ color: 'black' }}> Question Bank <br/>
                    <a href="https://drive.google.com/file/d/1we6MHM7BpOWauejQT1tkKzwY5xLdM9na/view?usp=sharing">Module 1</a><br/>
                    <a href="https://drive.google.com/file/d/1T2pfYpAH9KO4_VqX_16x3gVz4Jgptf8L/view?usp=sharing">Module 2</a><br/>
                    <a href="https://drive.google.com/file/d/1Tt55wh6-eUlQAxmkJXGy3eybZQ4Zlg02/view?usp=sharing">Module 3</a><br/>
                    <a href="https://drive.google.com/file/d/1GpwML4g84Ppl1ehkz9qrAiUfAhYO7YD_/view?usp=sharing">Module 4</a><br/>
                    <a href="https://drive.google.com/file/d/1D-gIqJxHOAoWBgFirI-51r1hACYft1DE/view?usp=sharing">Module 5</a><br/>
                    
                       
                    </div>
          </Typography>

          <Typography style={{ marginLeft: "30px" }}>
                    <div style={{ color: 'black' }}> Previous year Queston Paper<br/>
                    <a href="https://drive.google.com/file/d/1opAlJ8YlSwhk1OY7K81zQq8Uj-oCVC-j/view?usp=sharing">Jan 2019</a><br/>
                    <a href="https://drive.google.com/file/d/1z9NiC7-awPiaq1aBUFUXKIjASv1bmp7Z/view?usp=sharing">July 2019</a><br/>

                    
                       
                    </div>
          </Typography>
                </ExpansionPanelDetails>
            </ExpansionPanel>

            <ExpansionPanel expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
                <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel4bh-content"
                    id="panel4bh-header"
                >
                    <Typography className={classes.heading}>Unix System Programming</Typography>
                    <Typography  style={{marginLeft:'30px'}}  className={classes.secondaryHeading}>Not Available</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <Typography>
                    <div style={{ color: 'black' }}>
             
                      
                    </div>
          </Typography>
                </ExpansionPanelDetails>
            </ExpansionPanel>

            <ExpansionPanel expanded={expanded === 'panel6'} onChange={handleChange('panel6')}>
                <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel4bh-content"
                    id="panel4bh-header"
                >
                    <Typography className={classes.heading}>INS</Typography>
                      <Typography style={{marginLeft:'30px'}} className={classes.secondaryHeading}>Not Available</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <Typography>
                        <div style={{ color: 'black' }}>
                           
                        </div>
          </Typography>
                </ExpansionPanelDetails>
            </ExpansionPanel>
           
           <Footer/>
    

            
        </div>
    );
}
